"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZeroedHeatMap = exports.getDayRange = exports.getWeekRange = exports.useDateRangeWith = exports.useDateRange = void 0;
var lodash_1 = __importDefault(require("lodash"));
var time_1 = require("../../../../../../../server/util/time");
var useDateRange = function (days) {
    var range = [];
    for (var i = 0; i < days; i += 1) {
        range.unshift({
            date: (0, time_1.getLocalDayGroup)(-i),
            clicks: 0,
        });
    }
    return range;
};
exports.useDateRange = useDateRange;
var useDateRangeWith = function (data, days) {
    var range = (0, exports.useDateRange)(days);
    data.forEach(function (item) {
        range
            .filter(function (rangeItem) { return rangeItem.date === item.date; })
            .forEach(function (rangeItem) {
            // eslint-disable-next-line no-param-reassign
            rangeItem.clicks = item.clicks;
        });
    });
    return range;
};
exports.useDateRangeWith = useDateRangeWith;
var getWeekRange = function () {
    return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
};
exports.getWeekRange = getWeekRange;
var getDayRange = function () {
    var hours = lodash_1.default.range(0, 24);
    return hours.map(function (hour) {
        if (hour === 0)
            return '12am';
        if (hour < 12)
            return "".concat(hour, "am");
        if (hour === 12)
            return '12pm';
        return "".concat(hour - 12, "pm");
    });
};
exports.getDayRange = getDayRange;
var getZeroedHeatMap = function () {
    var days = (0, exports.getWeekRange)();
    var hours = (0, exports.getDayRange)();
    var zeroredData = [];
    days.forEach(function (day) {
        return hours.forEach(function (hour) { return zeroredData.push({ x: hour, y: day, color: 0 }); });
    });
    return zeroredData;
};
exports.getZeroedHeatMap = getZeroedHeatMap;
